module.exports = __webpack_public_path__ + "img/login-img2.72cd8a26.svg";